import React from 'react';
import {__GPYInit,_GPY} from './env.js'
import Wait from './Wait';

import Display from './scoreboard/display/Display.js';
import Scoreboard from './scoreboard/Scoreboard.js'
import Login from './login/Login.js'

class Guppyi extends React.Component {

	constructor(props) {
			super(props);
			this.state = {
 				 initComplete : false,
 			};
			__GPYInit(()=>{
				this.setState({initComplete:true});
			});
	}

	loadUIStates(){
		__GPYInit(()=>{
			this.setState({initComplete:true});
			this.forceUpdate();
		});
	}




  render () {
				if(_GPY.displayMode) {
				   if(_GPY.uiStates.__display === _GPY.did && _GPY.uiStates.__displayGameType === _GPY.uiStates.gameType) {
							return (<Display overflow="hidden" width={Math.floor(_GPY.uiStates.__displayFormat*1.7777777778)} gameType={_GPY.uiStates.__displayGameType} height={_GPY.uiStates.__displayFormat} theme={_GPY.uiStates.__displayTheme} layoutId={_GPY.uiStates.__displayLayout} guppyi={this} backgroundColor="rgba(0, 0, 0, 0)"/>)
					 } else {
							return (<Wait displayMode="true" width="1280" height="720" message={_GPY.i18n.get('wait_output_waiting_for_user_login','Waiting for guppyi login')}/>)
					}
				} else {
					if(this.state.initComplete) {
							if(_GPY.acc !== undefined && _GPY.acc === 'reset') {
									return (<Login guppyi={this} form="LoginResetPassword"/>)
							} else {
									if (_GPY.uiStates.userIsLoggedIn) {
										return (<Scoreboard guppyi={this}/>)
									} else {
										return (<Login guppyi={this}/>)
									}
						 }
					 } else {
									return (<Wait message={_GPY.i18n.get('wait_any_waiting_for_connection',"Connect..")}/>)
					 }
				}
    }
}
export default Guppyi;
